import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { getNextPage, getPreviousPage } from "../actions";
import { localStateSelector } from "../selectors";
import Component, { type PaginationActionProps, type PaginationMapProps } from "./component";

const makeMapStateToProps = () => {
  return (state: AppState, props: RootContainerProps): PaginationMapProps => {
    const localState = localStateSelector(state, props);

    return {
      hasPrevious: localState.currentPage > 1,
      hasNext: localState.hasMore
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): PaginationActionProps => ({
  onPreviousClick: () => dispatch(getPreviousPage({ id: props.id, source: props.source })),
  onNextClick: () => dispatch(getNextPage({ id: props.id, source: props.source }))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
